<div class="relative bg-[#0A0E1F] text-center px-6 overflow-hidden">
  <!-- Top Curve -->
  <div class="absolute lg:top-[5rem] left-0 w-full overflow-hidden">
    <svg viewBox="0 0 1440 120" preserveAspectRatio="none" class="w-full h-[60px] sm:h-[100px]">
      <defs>
        <filter id="svgDropShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feDropShadow dx="0" dy="0" stdDeviation="20" flood-color="#19E4E0" flood-opacity="1"></feDropShadow>
        </filter>
      </defs>

      <!-- Base Background Fill -->
      <rect x="0" y="0" width="1440" height="120" fill="#0A0E1F"></rect>

      <!-- Curve with Glow -->
      <path d="M0,80 C480,0 960,0 1440,80 L1440,120 L0,120 Z" fill="#0A0E1F" filter="url(#svgDropShadow)"></path>
    </svg>
  </div>

  <!-- Content (center aligned with top space) -->
  <div class="relative z-10 flex flex-col items-center justify-center min-h-[35vh] lg:min-h-[50vh]">
    <!-- Heading -->
    <h2 class="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-6">
      Start your journey by creating your free <br class="hidden md:block" />
      <span class="text-white">Space today!</span>
    </h2>

    <!-- Button -->
    <div class="border-[2px] border-[#19E4E0] rounded-full inline-block p-[4px] z-10">
      <button type="submit"
        class=" px-28 py-[0.5rem] rounded-full shadow-md --button transition"
        (click)="onPlayGame()">
        Play Game
      </button>
    </div>
  </div>
</div>